const LIST_NAME = 'APS_BY_ACTIVITY_CATEGORY'

export default {
  LIST_NAME
}
